import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import show from "./modules/show"
import allInformationSet from "./modules/allInformationSet"
import user from "./modules/user"

const store = new Vuex.Store({
	modules: {
        show,
        allInformationSet,
        user
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js